const saveThemeDataCookie = (value) => {
  document.cookie = `bayerFarm_ThemeData=${value}`;
}

const getThemeDataFromCookie = () => {
  return document.cookie.replace(/(?:(?:^|.*;\s*)bayerFarm_ThemeData\s*=\s*([^;]*).*$)|^.*$/, "$1");
}

export {
  saveThemeDataCookie,
  getThemeDataFromCookie,
};
